// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"7bb7779c","362":"8b764af4","497":"3fadc806","790":"32837c85","826":"da1b9986"}[chunkId] + ".chunk.js";
};